module.exports = __webpack_public_path__ + "static/media/Arshan_Dabirsiaghi.84782239.png";